import { useEffect, useRef, useState } from 'react'
import { useSpinDelay } from 'spin-delay'

export function useFakeDirty(useTimer = true) {
  const [isDirty, setIsDirty] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (!isDirty || !useTimer) {
      return
    }

    timeoutRef.current = setTimeout(() => setIsDirty(false), 3000)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [isDirty, useTimer])

  const delayedIsDirty = useSpinDelay(isDirty, {
    delay: 300,
    minDuration: 5000,
  })

  return [delayedIsDirty, setIsDirty] as const
}
